import { render, staticRenderFns } from "./CheckoutStepPayment.vue?vue&type=template&id=2dcb555c&scoped=true&"
import script from "./CheckoutStepPayment.vue?vue&type=script&lang=js&"
export * from "./CheckoutStepPayment.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutStepPayment.vue?vue&type=style&index=0&id=2dcb555c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb555c",
  null
  
)

export default component.exports